var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavArmiesSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.612 28.413c0-2.16 0.050-3.897 0-5.63-0.045-1.039-0.195-2.022-0.44-2.965l0.022 0.098c-0.301-1.133-0.473-2.434-0.473-3.775 0-1.806 0.313-3.538 0.887-5.147l-0.033 0.107c1.595-4.701 6.601-8.137 11.913-8.137 1.715 0.041 3.353 0.17 4.964 0.385l-0.23-0.025c1.306 0.138 2.62 0.255 3.935 0.306s2.608 0 4.186 0c0 1.565 0.046 2.867 0.033 4.186 0.021 1.837 0.236 3.612 0.627 5.321l-0.032-0.168c1.884 9.661-5.408 16.492-12.465 16.324-1.582-0.033-3.156-0.419-4.738-0.565-1.377-0.142-2.758-0.251-4.14-0.306-1.226-0.046-2.461-0.008-4.014-0.008zM16.023 28.217c7.266 0 12.063-5.86 12.063-12.21 0-7.116-5.128-12.088-12.109-12.063-7.132 0.025-12.084 5.128-12.063 12.105 0.025 7.137 3.926 11.13 12.109 12.168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.862 10.272c-2.093 4.47-4.127 8.748-6.325 13.394-0.059 0.105-2.030-5.023-2.030-5.023l-5.023-1.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3 7.137v0.067c-0 0.044-0.001 0.096-0.001 0.149 0 0.849 0.055 1.685 0.162 2.506l-0.010-0.097c0.869 1.814 1.377 3.943 1.377 6.191 0 0.015-0 0.029-0 0.044v-0.002c-0.054 8.156-6.679 14.747-14.842 14.747-1.948 0-3.808-0.375-5.512-1.057l0.1 0.035q-1.519-0.146-3.043-0.222c2.402 1.515 5.324 2.414 8.455 2.414 8.81 0 15.959-7.115 16.014-15.912l0-0.005c0-0.010 0-0.021 0-0.032 0-3.293-1.009-6.35-2.735-8.879l0.035 0.054z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.553 23.374c0-0.486-0.067-0.975-0.134-1.461-0.785-1.734-1.243-3.76-1.243-5.893 0-0.009 0-0.018 0-0.027v0.001c0.055-8.151 6.675-14.737 14.834-14.737 2.179 0 4.249 0.47 6.113 1.314l-0.093-0.038c0.9 0.080 1.804 0.142 2.704 0.18h0.071c-2.475-1.645-5.516-2.625-8.786-2.625-8.807 0-15.954 7.108-16.018 15.9l-0 0.006c0 0.007-0 0.014-0 0.022 0 3.216 0.964 6.207 2.619 8.7l-0.036-0.058c-0.004-0.427-0.013-0.858-0.029-1.285z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavArmiesSvg1);
export default __webpack_public_path__ + "static/media/nav-armies-svg-1.51c840695072ce17e193e33b853c9cbf.svg";
export { ForwardRef as ReactComponent };